import { Badge, Button, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import React, { Component } from "react";
import axios from "../../axios";
import AddSharpIcon from '@material-ui/icons/AddSharp';
import CreateIntegrationApiToken from "../create-api-token/create-api-token";
import apiError from "../../error";
import { toast } from "react-toastify";
import { getDate } from "../../function";
import swal from "sweetalert";

export default class CompanyIntegration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            integrations: [],
            showModal: false,
            companyIntegrationApiToken: {}
        };
    }

    hideModal = () => {
        this.setState({ showModal: false });
        this.fetchCompanyIntegrations();
    }
    componentDidMount = () => {
        this.fetchCompanyIntegrations();
    }

    fetchCompanyIntegrations = async () => {
        try {
            this.setState({ loading: true });
            const response = await axios.get('/api/company-integration/api-token');
            this.setState({ companyIntegrationApiToken: response.data.companyIntegration, loading: false });
        } catch (error) {
            this.setState({ loading: false });
            apiError(error);
        }

    }
    handleDeleteApiToken = async () => {
        if (!this.state.companyIntegrationApiToken || Object.keys(this.state.companyIntegrationApiToken).length === 0) {
            toast.error("No API token found to delete");
            return;
        }
        try {
            let shouldDelete = await swal({
                title: "Are you sure you want to delete this API token?",
                icon: "warning",
                buttons: ["No", "Yes"],
                dangerMode: true,
            })
            if (!shouldDelete) return;
            this.setState({ loading: true });
            await axios.delete(`/api/company-integration/delete-api-token/${this.state.companyIntegrationApiToken.id}`);
            this.setState({ companyIntegrationApiToken: {}, loading: false });
            toast.success("API Token deleted successfully");
        } catch (error) {
            this.setState({ loading: false });
            apiError(error);
        }
    }

    render() {
        return (
            <div className="tab-wrap">
                <div className='tabHeading'>
                    <h6>API Token</h6>
                    <p>Your API tokens should be stored securely and rotated regularly..</p>
                </div>
                <div className="tableContainerWrapInner">
                    <Table responsive>
                        <thead className="bg-light">
                            <tr>
                                <th>Token Name</th>
                                <th>Created On</th>
                                <th>Last Accessed</th>
                                <th>Expires On</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(!this.state.companyIntegrationApiToken || Object.keys(this.state.companyIntegrationApiToken).length === 0) ?
                                <p className="m-2">No data found</p> : (
                                    <tr>
                                        <td>{this.state.companyIntegrationApiToken.apiKeyName}</td>
                                        <td>{getDate(this.state.companyIntegrationApiToken.createdAt)}</td>
                                        <td>{getDate(this.state.companyIntegrationApiToken.apiKeyLastAccess)}</td>
                                        <td>{getDate(this.state.companyIntegrationApiToken.apiKeyExpiryDate)}</td>
                                        <td>
                                            <Badge pill className={(this.state.companyIntegrationApiToken.status === "Active") ? "alert-success" : "badge-soft-danger"}>{this.state.companyIntegrationApiToken.status}</Badge>

                                        </td>
                                        <td style={{ cursor: 'pointer', fontWeight: 'bold', color: 'rgb(74, 131, 218)' }} onClick={this.handleDeleteApiToken}>Delete</td>
                                    </tr>
                                )}
                        </tbody>

                    </Table>
                </div>
                <div className="mt-3">
                    <OverlayTrigger
                        placement="bottom"
                        overlay={
                            !this.props.permissibleActionsIAM['setting-write']
                                ? (<Tooltip id="bottom">You don't have permission to access</Tooltip>)
                                : (this.state.companyIntegrationApiToken?.status==="Active"? <Tooltip id="bottom">An API Token already exists</Tooltip>:<Tooltip className="d-none"></Tooltip>)
                        }
                    >
                        <Button
                            variant="primary"
                            onClick={() => this.props.permissibleActionsIAM['setting-write'] && !(this.state.companyIntegrationApiToken?.status==="Active") && this.setState({ showModal: true })}
                            className={`${(this.state.companyIntegrationApiToken?.status==="Active" || !this.props.permissibleActionsIAM['setting-write']) ? "disabledCls" : ""}`}
                        >
                            <AddSharpIcon className="btn-icon"></AddSharpIcon>Create API Token
                        </Button>

                    </OverlayTrigger>
                    <a
                        href={`${process.env.REACT_APP_API_URL}/api-docs`}
                        style={{ fontSize: "12px", textDecoration: "underline", marginLeft: "15px" }}
                        target="blank"
                    >
                        TSAT API Documentation
                    </a>

                    <CreateIntegrationApiToken showModal={this.state.showModal} hideModal={this.hideModal} />

                </div>
            </div>
        )

    }
}